import React from 'react';
import { formatAssociatedOrderNumberForDisplay, formatOrderDateToLocalTime } from '../../../util';
import { Row, TableData } from 'components/common/tableElements';
import { STATUS_MAP } from 'constants/rbi';

const SalesforceSearchResult = ({ result, clickAction, even }) => (
  <Row onClick={() => clickAction(result)} hoverPointer={true} even={even}>
    <TableData>{formatAssociatedOrderNumberForDisplay(result.OrderNumber)}</TableData>
    <TableData>{formatOrderDateToLocalTime(result.CreatedDate, 'salesforce')}</TableData>
    <TableData>{result.EstimatedShippingDate || '-'}</TableData>
    <TableData>{STATUS_MAP[result.Status] || result.Status}</TableData>
  </Row>
);

export default SalesforceSearchResult;
